export function getContestStatus(startedAt, endedAt) {
  if (Date.now() > new Date(endedAt).getTime()) return "已结束";
  if (Date.now() < new Date(startedAt).getTime()) return "未开始";
  return "进行中";
}
